// extracted by mini-css-extract-plugin
module.exports = {"goBack":"styles_goBack__1KvWG","goBackIcon":"styles_goBackIcon__1XTm3"};